/* ################################################################### */
/* FUNCTION (ALERT WINDOW) ########################################### */
/* ################################################################### */
function alertWindow(speed, ease)
{
	/* --- Open / Close --- */
	jQuery('.js-alert_trigger').on('click', function(e)
	{
		e.preventDefault();
		e.stopPropagation();

		var jQuery_this = jQuery(this);
			idAlert     = jQuery_this.attr('data-alert');

		openCloseAlertwindow(idAlert);
	});

	/* --- Highlight on click outside --- */
	jQuery('.js-alert_content').on('click', function(e)
	{
		e.preventDefault();
		e.stopPropagation();

		if(jQuery('.js-alert_content .content:hover').length == 0)
		{
			for(i = 0; i < 6; i++)
			{
				setTimeout(function()
				{
					jQuery('.content .dismiss', '.js-alert_content').toggleClass('highlight');
				}, i * speed);
			}
		}
	});
}

function openCloseAlertwindow(idAlert)
{
	if(jQuery(idAlert).hasClass('open'))
	{
		jQuery(idAlert).removeClass('open');
		document.body.style.overflow = "";
	}
	else
	{
		jQuery(idAlert).addClass('open');
		document.body.style.overflow = "hidden";
	}

	jQuery(idAlert).stop(true, true).fadeToggle(speed, ease);
}
